import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["companyId", "companyName", "companyWebsite", "createSection", "selectedDisplay", "selectedName"]

  connect() {
    this.element.addEventListener("stepper:validate", this.validate.bind(this))
  }

  // Called via data-action="autocomplete:select->add-sponsor#companySelected"
  companySelected(event) {
    const { value, data } = event.detail || {}
    if (!data?.id) return

    this.companyIdTarget.value = data.id
    this.selectedNameTarget.textContent = value || data.name
    this.selectedDisplayTarget.classList.remove("hidden")
    this.createSectionTarget.classList.add("hidden")
    this.companyNameTarget.value = ""
    this.companyWebsiteTarget.value = ""
  }

  clearSelection() {
    this.companyIdTarget.value = ""
    this.selectedDisplayTarget.classList.add("hidden")
    this.createSectionTarget.classList.remove("hidden")
  }

  nameInput() {
    if (this.companyNameTarget.value.trim() !== "" && this.companyIdTarget.value !== "") {
      this.companyIdTarget.value = ""
      this.selectedDisplayTarget.classList.add("hidden")
    }
  }

  searchInput() {
    if (this.companyIdTarget.value !== "") {
      this.clearSelection()
    }
  }

  validate(event) {
    if (event.detail.step !== 0) return

    const hasSelection = this.companyIdTarget.value !== ""
    const hasName = this.companyNameTarget.value.trim() !== ""

    if (!hasSelection && !hasName) {
      event.preventDefault()
    }
  }
}
